import React, { useState, useEffect } from 'react';
import BookingConfirmation from './BookingConfirmation';
import Swal from "sweetalert2";
import axios from 'axios';
import { hasPrivilege } from '../utils/hasPrivilege';
import { useUser } from '../context/UserContext';

const SwimmingConfirmation = ({ bookingDetails, onClose, onConfirm }) => {
    const [guestCount, setGuestCount] = useState('1');
    const { userData } = useUser();
    const [confirmedDetails, setConfirmedDetails] = useState(null);
    const [showAllGuests, setShowAllGuests] = useState(false);
    const [swimmingGuests, setSwimmingGuests] = useState([]);
    const token = localStorage.getItem('auth-token');
    useEffect(() => {

        const fetchGuestData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL_SWIMMING_DATA}?Date=${bookingDetails.date}&courtTimingId=${bookingDetails.courtTimingId}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                const bookings = response.data?.data?.bookings || [];

                const formattedGuests = bookings.map((booking) => ({
                    name: booking.userName,
                    contact: booking.mobileNumber,
                    amount: `₹${booking.amount || 0}`,
                    source: booking.source || 'Unknown',
                    guestCount:booking.guestCount ||0,
                }));

                setSwimmingGuests(formattedGuests);
            } catch (error) {
                console.error("Error fetching guest data:", error);
                Swal.fire({
                    icon: "error",
                    title: "API Error",
                    text: "Could not load guest bookings.",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                });
            }
        };

        fetchGuestData();
    }, [bookingDetails]);



    const handleConfirm = () => {
        if (!guestCount || isNaN(guestCount) || parseInt(guestCount) <= 0) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Enter a valid guest count.",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });
            return;
        }

        const availableSpots = bookingDetails.maxPlayersAllowed - bookingDetails.bookedPlayers;
        if (parseInt(guestCount) > availableSpots) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: `Only ${availableSpots} guests can be booked.`,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });
            return;
        }

        const finalDetails = {
            sportId: bookingDetails.sportId,
            date: bookingDetails.date,
            academyId: bookingDetails.academyId,
            courtTimingIds: [bookingDetails.courtTimingId],
            guestCount: parseInt(guestCount),
        };

       
        setConfirmedDetails(finalDetails);
    };

    const handleBookingSuccess = () => {

        if (onClose) onClose(); 
        if (confirmedDetails && typeof onConfirm === 'function') {
            onConfirm(confirmedDetails); 
        }
    };
    

    const visibleGuests = showAllGuests ? swimmingGuests : swimmingGuests.slice(0, 1);

    return (
        <div style={{ padding: '0px' }}>
            <div className="swimming-confirmation-panel">
                <h3>Swimming Slot Confirmation</h3>
                <p><strong>Time Slot:</strong> {bookingDetails.time}</p>

                {swimmingGuests.length > 0 && (
                    <div style={{ marginBottom: '16px' }}>
                        <h4>Guest List</h4>
                        <div style={{ maxHeight: '200px', overflowY: 'auto', marginTop: '8px' }}>
                            <table className="guest-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Contact</th>
                                        <th>Amount</th>
                                        <th>Source</th>
                                        <th>Users</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {visibleGuests.map((guest, index) => (
                                        <tr key={index}>
                                            <td style={{ whiteSpace: 'nowrap' }}>{guest.name}</td>
                                            <td>{guest.contact}</td>
                                            <td>{guest.amount}</td>
                                            <td>{guest.source}</td>
                                            <td>{guest.guestCount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>


                        {!showAllGuests && swimmingGuests.length > 1 && (
                            <button
                                onClick={() => setShowAllGuests(true)}
                                style={{ marginTop: '10px', cursor: 'pointer', background: '#003b72', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '4px' }}
                            >
                                Show All Guests ({swimmingGuests.length-1})
                            </button>
                        )}
                    </div>
                )}


{hasPrivilege(userData, 'COURTS', 'BOOKING_CALENDAR_MODIFY') && (
  <>
    <div className="floating-select-form" style={{ width: '100%' }}>
      <input
        type="text"
        className={`walkin-form ${guestCount ? 'has-value' : ''}`}
        placeholder="Enter User Count"
        value={guestCount || ''}
        onChange={(e) => {
          const onlyNums = e.target.value.replace(/[^0-9]/g, '');
          setGuestCount(onlyNums);
          setConfirmedDetails(null);
        }}
        style={{ width: '93%' }}
      />
      {guestCount && <label htmlFor="guestCount">User Count</label>}
    </div>

    <div style={{ marginTop: '16px' }}>
      {!confirmedDetails && (
        <button onClick={handleConfirm} className="booking-main-button">Confirm</button>
      )}
    </div>
  </>
)}

            </div>

            {confirmedDetails && (
                <div style={{ marginTop: '20px' }}>
                    <BookingConfirmation
                        bookingDetails={confirmedDetails}
                        onBookingSuccess={handleBookingSuccess}
                    />
                </div>
            )}
        </div>
    );
};

export default SwimmingConfirmation;
